/**
 * @param {number} totalItems
 * @param {number} [pageSize=15]
 */
export function getTotalPages(totalItems, pageSize = 15) {
  if (totalItems <= 0) {
    return 1
  }

  return Math.ceil(totalItems / pageSize)
}

/**
 * @template T
 * @param {T[]} items
 * @param {number} page
 * @param {number} [pageSize=15]
 * @returns {T[]}
 */
export function paginateItems(items, page, pageSize = 15) {
  const safePage = Math.max(1, page)
  const start = (safePage - 1) * pageSize
  return items.slice(start, start + pageSize)
}
